module.exports = __webpack_public_path__ + "static/media/work (10).01b92ecf.jpg";